/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Booking API
 * Booking API
 * OpenAPI spec version: 1.29.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddAppointment200,
  AvailableTimes200,
  AvailableTimesParams,
  CancelAppointment200,
  CreateAppointmentSlot200,
  CreateTherapist200,
  CreateTherapistAllocation200,
  CustomerRecentServices200,
  CustomerRecentServicesParams,
  CustomerUpcomingAppointments200,
  CustomerUpcomingAppointmentsParams,
  DeleteAppointment201,
  DeleteSchedulableItems200,
  DeleteTherapistAllocation200,
  GetAllAppointmentSlots200,
  GetAllTherapistAllocations200,
  GetAllTherapists200,
  GetAllTherapistsParams,
  GetAppointment200,
  GetAppointmentSlotsPurchasableItems200,
  GetAppointments200,
  GetAppointmentsParams,
  GetCocktailIngredients200,
  GetCocktailIngredientsParams,
  GetDripIngredientsAndIvPricing200,
  GetServices200,
  GetSlots200,
  GetTherapist200,
  IsCustomerFirstTime200,
  IsCustomerFirstTimeParams,
  MissedAppointment200,
  MultiDayAvailableTimes200,
  MultiDayAvailableTimesParams,
  SchedulableItems200,
  SchedulableItemsV1200,
  SendConfirmationEmailForAppointments200,
  SetAppointmentSlotItemsRequestPayload,
  SetSchedulableItems200,
  StaffAddAppointmentRequest,
  StaffCancelAppointmentRequestPayload,
  StaffCreateAppointmentSlotRequest,
  StaffCreateTherapistAllocationRequestPayload,
  StaffCreateTherapistRequest,
  StaffMissedAppointmentRequestPayload,
  StaffSendConfirmationEmailRequestPayload,
  StaffUpdateAppointmentRequest,
  StaffUpdateAppointmentSlotRequest,
  StaffUpdateAppointmentStatusForClientDayRequest,
  StaffUpdateTherapistRequest,
  StatusUpdateForClientDay200,
  UpdateAppointment200,
  UpdateTherapist200
} from './booking-api.schemas';

import { bookingApiInstance } from '../../common/axios/orvalMutator';
import type { ErrorType, BodyType } from '../../common/axios/orvalMutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getAllAppointmentSlots = (
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetAllAppointmentSlots200>(
    { url: `/staff/appointment-slots`, method: 'GET' },
    options
  );
};

export const getGetAllAppointmentSlotsQueryKey = () => {
  return [`/staff/appointment-slots`] as const;
};

export const getGetAllAppointmentSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAppointmentSlots>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllAppointmentSlots>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllAppointmentSlotsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllAppointmentSlots>>
  > = () => getAllAppointmentSlots(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAppointmentSlots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllAppointmentSlotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllAppointmentSlots>>
>;
export type GetAllAppointmentSlotsQueryError = ErrorType<unknown>;

export function useGetAllAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAllAppointmentSlots>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAppointmentSlots>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAppointmentSlots>>,
          TError,
          Awaited<ReturnType<typeof getAllAppointmentSlots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAllAppointmentSlots>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAppointmentSlots>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAppointmentSlots>>,
          TError,
          Awaited<ReturnType<typeof getAllAppointmentSlots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAllAppointmentSlots>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAppointmentSlots>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAllAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAllAppointmentSlots>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAppointmentSlots>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllAppointmentSlotsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAppointmentSlot = (
  staffCreateAppointmentSlotRequest: BodyType<StaffCreateAppointmentSlotRequest>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<CreateAppointmentSlot200>(
    {
      url: `/staff/appointment-slots`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateAppointmentSlotRequest
    },
    options
  );
};

export const getCreateAppointmentSlotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAppointmentSlot>>,
    TError,
    { data: BodyType<StaffCreateAppointmentSlotRequest> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAppointmentSlot>>,
  TError,
  { data: BodyType<StaffCreateAppointmentSlotRequest> },
  TContext
> => {
  const mutationKey = ['createAppointmentSlot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAppointmentSlot>>,
    { data: BodyType<StaffCreateAppointmentSlotRequest> }
  > = props => {
    const { data } = props ?? {};

    return createAppointmentSlot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAppointmentSlotMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAppointmentSlot>>
>;
export type CreateAppointmentSlotMutationBody =
  BodyType<StaffCreateAppointmentSlotRequest>;
export type CreateAppointmentSlotMutationError = ErrorType<unknown>;

export const useCreateAppointmentSlot = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAppointmentSlot>>,
      TError,
      { data: BodyType<StaffCreateAppointmentSlotRequest> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAppointmentSlot>>,
  TError,
  { data: BodyType<StaffCreateAppointmentSlotRequest> },
  TContext
> => {
  const mutationOptions = getCreateAppointmentSlotMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateAppointmentsSlot = (
  id: number,
  staffUpdateAppointmentSlotRequest: BodyType<StaffUpdateAppointmentSlotRequest>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<boolean>(
    {
      url: `/staff/appointment-slots/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateAppointmentSlotRequest
    },
    options
  );
};

export const getUpdateAppointmentsSlotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAppointmentsSlot>>,
    TError,
    { id: number; data: BodyType<StaffUpdateAppointmentSlotRequest> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAppointmentsSlot>>,
  TError,
  { id: number; data: BodyType<StaffUpdateAppointmentSlotRequest> },
  TContext
> => {
  const mutationKey = ['updateAppointmentsSlot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAppointmentsSlot>>,
    { id: number; data: BodyType<StaffUpdateAppointmentSlotRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return updateAppointmentsSlot(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAppointmentsSlotMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAppointmentsSlot>>
>;
export type UpdateAppointmentsSlotMutationBody =
  BodyType<StaffUpdateAppointmentSlotRequest>;
export type UpdateAppointmentsSlotMutationError = ErrorType<unknown>;

export const useUpdateAppointmentsSlot = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAppointmentsSlot>>,
      TError,
      { id: number; data: BodyType<StaffUpdateAppointmentSlotRequest> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAppointmentsSlot>>,
  TError,
  { id: number; data: BodyType<StaffUpdateAppointmentSlotRequest> },
  TContext
> => {
  const mutationOptions = getUpdateAppointmentsSlotMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteAppointmentSlot = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<boolean>(
    { url: `/staff/appointment-slots/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteAppointmentSlotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAppointmentSlot>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAppointmentSlot>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteAppointmentSlot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAppointmentSlot>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteAppointmentSlot(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAppointmentSlotMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAppointmentSlot>>
>;

export type DeleteAppointmentSlotMutationError = ErrorType<unknown>;

export const useDeleteAppointmentSlot = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAppointmentSlot>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAppointmentSlot>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAppointmentSlotMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const createTherapist = (
  staffCreateTherapistRequest: BodyType<StaffCreateTherapistRequest>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<CreateTherapist200>(
    {
      url: `/staff/therapists`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateTherapistRequest
    },
    options
  );
};

export const getCreateTherapistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTherapist>>,
    TError,
    { data: BodyType<StaffCreateTherapistRequest> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTherapist>>,
  TError,
  { data: BodyType<StaffCreateTherapistRequest> },
  TContext
> => {
  const mutationKey = ['createTherapist'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTherapist>>,
    { data: BodyType<StaffCreateTherapistRequest> }
  > = props => {
    const { data } = props ?? {};

    return createTherapist(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTherapistMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTherapist>>
>;
export type CreateTherapistMutationBody = BodyType<StaffCreateTherapistRequest>;
export type CreateTherapistMutationError = ErrorType<unknown>;

export const useCreateTherapist = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTherapist>>,
      TError,
      { data: BodyType<StaffCreateTherapistRequest> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTherapist>>,
  TError,
  { data: BodyType<StaffCreateTherapistRequest> },
  TContext
> => {
  const mutationOptions = getCreateTherapistMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getAllTherapists = (
  params?: GetAllTherapistsParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetAllTherapists200>(
    { url: `/staff/therapists`, method: 'GET', params },
    options
  );
};

export const getGetAllTherapistsQueryKey = (
  params?: GetAllTherapistsParams
) => {
  return [`/staff/therapists`, ...(params ? [params] : [])] as const;
};

export const getGetAllTherapistsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllTherapists>>,
  TError = ErrorType<unknown>
>(
  params?: GetAllTherapistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllTherapistsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllTherapists>>
  > = () => getAllTherapists(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllTherapists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllTherapistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllTherapists>>
>;
export type GetAllTherapistsQueryError = ErrorType<unknown>;

export function useGetAllTherapists<
  TData = Awaited<ReturnType<typeof getAllTherapists>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetAllTherapistsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapists>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTherapists>>,
          TError,
          Awaited<ReturnType<typeof getAllTherapists>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllTherapists<
  TData = Awaited<ReturnType<typeof getAllTherapists>>,
  TError = ErrorType<unknown>
>(
  params?: GetAllTherapistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapists>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTherapists>>,
          TError,
          Awaited<ReturnType<typeof getAllTherapists>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllTherapists<
  TData = Awaited<ReturnType<typeof getAllTherapists>>,
  TError = ErrorType<unknown>
>(
  params?: GetAllTherapistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAllTherapists<
  TData = Awaited<ReturnType<typeof getAllTherapists>>,
  TError = ErrorType<unknown>
>(
  params?: GetAllTherapistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllTherapistsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteTherapist = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<null>(
    { url: `/staff/therapists/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteTherapistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTherapist>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTherapist>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteTherapist'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTherapist>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteTherapist(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTherapistMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTherapist>>
>;

export type DeleteTherapistMutationError = ErrorType<unknown>;

export const useDeleteTherapist = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTherapist>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTherapist>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTherapistMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateTherapist = (
  id: number,
  staffUpdateTherapistRequest: BodyType<StaffUpdateTherapistRequest>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<UpdateTherapist200>(
    {
      url: `/staff/therapists/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateTherapistRequest
    },
    options
  );
};

export const getUpdateTherapistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTherapist>>,
    TError,
    { id: number; data: BodyType<StaffUpdateTherapistRequest> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTherapist>>,
  TError,
  { id: number; data: BodyType<StaffUpdateTherapistRequest> },
  TContext
> => {
  const mutationKey = ['updateTherapist'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTherapist>>,
    { id: number; data: BodyType<StaffUpdateTherapistRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return updateTherapist(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTherapistMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTherapist>>
>;
export type UpdateTherapistMutationBody = BodyType<StaffUpdateTherapistRequest>;
export type UpdateTherapistMutationError = ErrorType<unknown>;

export const useUpdateTherapist = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTherapist>>,
      TError,
      { id: number; data: BodyType<StaffUpdateTherapistRequest> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTherapist>>,
  TError,
  { id: number; data: BodyType<StaffUpdateTherapistRequest> },
  TContext
> => {
  const mutationOptions = getUpdateTherapistMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getTherapist = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetTherapist200>(
    { url: `/staff/therapist/${id}`, method: 'GET' },
    options
  );
};

export const getGetTherapistQueryKey = (id?: number) => {
  return [`/staff/therapist/${id}`] as const;
};

export const getGetTherapistQueryOptions = <
  TData = Awaited<ReturnType<typeof getTherapist>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTherapist>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTherapistQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTherapist>>> = () =>
    getTherapist(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTherapist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTherapistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTherapist>>
>;
export type GetTherapistQueryError = ErrorType<unknown>;

export function useGetTherapist<
  TData = Awaited<ReturnType<typeof getTherapist>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTherapist>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTherapist>>,
          TError,
          Awaited<ReturnType<typeof getTherapist>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTherapist<
  TData = Awaited<ReturnType<typeof getTherapist>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTherapist>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTherapist>>,
          TError,
          Awaited<ReturnType<typeof getTherapist>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTherapist<
  TData = Awaited<ReturnType<typeof getTherapist>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTherapist>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTherapist<
  TData = Awaited<ReturnType<typeof getTherapist>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTherapist>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTherapistQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAllTherapistAllocations = (
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetAllTherapistAllocations200>(
    { url: `/staff/therapist-allocations`, method: 'GET' },
    options
  );
};

export const getGetAllTherapistAllocationsQueryKey = () => {
  return [`/staff/therapist-allocations`] as const;
};

export const getGetAllTherapistAllocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllTherapistAllocations>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllTherapistAllocations>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllTherapistAllocationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllTherapistAllocations>>
  > = () => getAllTherapistAllocations(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllTherapistAllocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllTherapistAllocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllTherapistAllocations>>
>;
export type GetAllTherapistAllocationsQueryError = ErrorType<unknown>;

export function useGetAllTherapistAllocations<
  TData = Awaited<ReturnType<typeof getAllTherapistAllocations>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapistAllocations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTherapistAllocations>>,
          TError,
          Awaited<ReturnType<typeof getAllTherapistAllocations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllTherapistAllocations<
  TData = Awaited<ReturnType<typeof getAllTherapistAllocations>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapistAllocations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTherapistAllocations>>,
          TError,
          Awaited<ReturnType<typeof getAllTherapistAllocations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllTherapistAllocations<
  TData = Awaited<ReturnType<typeof getAllTherapistAllocations>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapistAllocations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAllTherapistAllocations<
  TData = Awaited<ReturnType<typeof getAllTherapistAllocations>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllTherapistAllocations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllTherapistAllocationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTherapistAllocation = (
  id: number,
  staffCreateTherapistAllocationRequestPayload: BodyType<StaffCreateTherapistAllocationRequestPayload>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<CreateTherapistAllocation200>(
    {
      url: `/staff/appointment-slots/${id}/therapist-allocations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateTherapistAllocationRequestPayload
    },
    options
  );
};

export const getCreateTherapistAllocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTherapistAllocation>>,
    TError,
    {
      id: number;
      data: BodyType<StaffCreateTherapistAllocationRequestPayload>;
    },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTherapistAllocation>>,
  TError,
  { id: number; data: BodyType<StaffCreateTherapistAllocationRequestPayload> },
  TContext
> => {
  const mutationKey = ['createTherapistAllocation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTherapistAllocation>>,
    { id: number; data: BodyType<StaffCreateTherapistAllocationRequestPayload> }
  > = props => {
    const { id, data } = props ?? {};

    return createTherapistAllocation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTherapistAllocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTherapistAllocation>>
>;
export type CreateTherapistAllocationMutationBody =
  BodyType<StaffCreateTherapistAllocationRequestPayload>;
export type CreateTherapistAllocationMutationError = ErrorType<unknown>;

export const useCreateTherapistAllocation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTherapistAllocation>>,
      TError,
      {
        id: number;
        data: BodyType<StaffCreateTherapistAllocationRequestPayload>;
      },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTherapistAllocation>>,
  TError,
  { id: number; data: BodyType<StaffCreateTherapistAllocationRequestPayload> },
  TContext
> => {
  const mutationOptions = getCreateTherapistAllocationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteTherapistAllocation = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<DeleteTherapistAllocation200>(
    {
      url: `/staff/appointment-slots/therapist-allocations/${id}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteTherapistAllocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTherapistAllocation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTherapistAllocation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteTherapistAllocation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTherapistAllocation>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteTherapistAllocation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTherapistAllocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTherapistAllocation>>
>;

export type DeleteTherapistAllocationMutationError = ErrorType<unknown>;

export const useDeleteTherapistAllocation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTherapistAllocation>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTherapistAllocation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTherapistAllocationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getAppointmentSlotsPurchasableItems = (
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetAppointmentSlotsPurchasableItems200>(
    { url: `/staff/appointment-slots/purchasable-items`, method: 'GET' },
    options
  );
};

export const getGetAppointmentSlotsPurchasableItemsQueryKey = () => {
  return [`/staff/appointment-slots/purchasable-items`] as const;
};

export const getGetAppointmentSlotsPurchasableItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAppointmentSlotsPurchasableItemsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>
  > = () => getAppointmentSlotsPurchasableItems(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentSlotsPurchasableItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>
>;
export type GetAppointmentSlotsPurchasableItemsQueryError = ErrorType<unknown>;

export function useGetAppointmentSlotsPurchasableItems<
  TData = Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAppointmentSlotsPurchasableItems<
  TData = Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAppointmentSlotsPurchasableItems<
  TData = Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAppointmentSlotsPurchasableItems<
  TData = Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointmentSlotsPurchasableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetAppointmentSlotsPurchasableItemsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAppointments = (
  params: GetAppointmentsParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetAppointments200>(
    { url: `/staff/appointments`, method: 'GET', params },
    options
  );
};

export const getGetAppointmentsQueryKey = (params?: GetAppointmentsParams) => {
  return [`/staff/appointments`, ...(params ? [params] : [])] as const;
};

export const getGetAppointmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>
>(
  params: GetAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAppointments>>
  > = () => getAppointments(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppointments>>
>;
export type GetAppointmentsQueryError = ErrorType<unknown>;

export function useGetAppointments<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>
>(
  params: GetAppointmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointments>>,
          TError,
          Awaited<ReturnType<typeof getAppointments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAppointments<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>
>(
  params: GetAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointments>>,
          TError,
          Awaited<ReturnType<typeof getAppointments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAppointments<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>
>(
  params: GetAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAppointments<
  TData = Awaited<ReturnType<typeof getAppointments>>,
  TError = ErrorType<unknown>
>(
  params: GetAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAppointments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAppointmentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addAppointment = (
  staffAddAppointmentRequest: BodyType<StaffAddAppointmentRequest>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<AddAppointment200>(
    {
      url: `/staff/appointments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffAddAppointmentRequest
    },
    options
  );
};

export const getAddAppointmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAppointment>>,
    TError,
    { data: BodyType<StaffAddAppointmentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addAppointment>>,
  TError,
  { data: BodyType<StaffAddAppointmentRequest> },
  TContext
> => {
  const mutationKey = ['addAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addAppointment>>,
    { data: BodyType<StaffAddAppointmentRequest> }
  > = props => {
    const { data } = props ?? {};

    return addAppointment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddAppointmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof addAppointment>>
>;
export type AddAppointmentMutationBody = BodyType<StaffAddAppointmentRequest>;
export type AddAppointmentMutationError = ErrorType<unknown>;

export const useAddAppointment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addAppointment>>,
      TError,
      { data: BodyType<StaffAddAppointmentRequest> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addAppointment>>,
  TError,
  { data: BodyType<StaffAddAppointmentRequest> },
  TContext
> => {
  const mutationOptions = getAddAppointmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateAppointment = (
  staffUpdateAppointmentRequest: BodyType<StaffUpdateAppointmentRequest>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<UpdateAppointment200>(
    {
      url: `/staff/appointments`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateAppointmentRequest
    },
    options
  );
};

export const getUpdateAppointmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAppointment>>,
    TError,
    { data: BodyType<StaffUpdateAppointmentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAppointment>>,
  TError,
  { data: BodyType<StaffUpdateAppointmentRequest> },
  TContext
> => {
  const mutationKey = ['updateAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAppointment>>,
    { data: BodyType<StaffUpdateAppointmentRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateAppointment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAppointmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAppointment>>
>;
export type UpdateAppointmentMutationBody =
  BodyType<StaffUpdateAppointmentRequest>;
export type UpdateAppointmentMutationError = ErrorType<unknown>;

export const useUpdateAppointment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAppointment>>,
      TError,
      { data: BodyType<StaffUpdateAppointmentRequest> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAppointment>>,
  TError,
  { data: BodyType<StaffUpdateAppointmentRequest> },
  TContext
> => {
  const mutationOptions = getUpdateAppointmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getAppointment = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetAppointment200>(
    { url: `/staff/appointments/${id}`, method: 'GET' },
    options
  );
};

export const getGetAppointmentQueryKey = (id?: number) => {
  return [`/staff/appointments/${id}`] as const;
};

export const getGetAppointmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointment>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAppointment>>
  > = () => getAppointment(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppointment>>
>;
export type GetAppointmentQueryError = ErrorType<unknown>;

export function useGetAppointment<
  TData = Awaited<ReturnType<typeof getAppointment>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointment>>,
          TError,
          Awaited<ReturnType<typeof getAppointment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAppointment<
  TData = Awaited<ReturnType<typeof getAppointment>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointment>>,
          TError,
          Awaited<ReturnType<typeof getAppointment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAppointment<
  TData = Awaited<ReturnType<typeof getAppointment>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAppointment<
  TData = Awaited<ReturnType<typeof getAppointment>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAppointmentQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteAppointment = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<DeleteAppointment201>(
    { url: `/staff/appointments/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeleteAppointmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAppointment>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAppointment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAppointment>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteAppointment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAppointmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAppointment>>
>;

export type DeleteAppointmentMutationError = ErrorType<unknown>;

export const useDeleteAppointment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAppointment>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAppointment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAppointmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const isCustomerFirstTime = (
  params: IsCustomerFirstTimeParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<IsCustomerFirstTime200>(
    { url: `/staff/firstTimeStatus`, method: 'GET', params },
    options
  );
};

export const getIsCustomerFirstTimeQueryKey = (
  params?: IsCustomerFirstTimeParams
) => {
  return [`/staff/firstTimeStatus`, ...(params ? [params] : [])] as const;
};

export const getIsCustomerFirstTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof isCustomerFirstTime>>,
  TError = ErrorType<unknown>
>(
  params: IsCustomerFirstTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isCustomerFirstTime>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getIsCustomerFirstTimeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof isCustomerFirstTime>>
  > = () => isCustomerFirstTime(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isCustomerFirstTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsCustomerFirstTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof isCustomerFirstTime>>
>;
export type IsCustomerFirstTimeQueryError = ErrorType<unknown>;

export function useIsCustomerFirstTime<
  TData = Awaited<ReturnType<typeof isCustomerFirstTime>>,
  TError = ErrorType<unknown>
>(
  params: IsCustomerFirstTimeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isCustomerFirstTime>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof isCustomerFirstTime>>,
          TError,
          Awaited<ReturnType<typeof isCustomerFirstTime>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIsCustomerFirstTime<
  TData = Awaited<ReturnType<typeof isCustomerFirstTime>>,
  TError = ErrorType<unknown>
>(
  params: IsCustomerFirstTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isCustomerFirstTime>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof isCustomerFirstTime>>,
          TError,
          Awaited<ReturnType<typeof isCustomerFirstTime>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIsCustomerFirstTime<
  TData = Awaited<ReturnType<typeof isCustomerFirstTime>>,
  TError = ErrorType<unknown>
>(
  params: IsCustomerFirstTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isCustomerFirstTime>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useIsCustomerFirstTime<
  TData = Awaited<ReturnType<typeof isCustomerFirstTime>>,
  TError = ErrorType<unknown>
>(
  params: IsCustomerFirstTimeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof isCustomerFirstTime>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getIsCustomerFirstTimeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const statusUpdateForClientDay = (
  staffUpdateAppointmentStatusForClientDayRequest: BodyType<StaffUpdateAppointmentStatusForClientDayRequest>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<StatusUpdateForClientDay200>(
    {
      url: `/staff/statusUpdateForClientDay`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateAppointmentStatusForClientDayRequest
    },
    options
  );
};

export const getStatusUpdateForClientDayMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof statusUpdateForClientDay>>,
    TError,
    { data: BodyType<StaffUpdateAppointmentStatusForClientDayRequest> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof statusUpdateForClientDay>>,
  TError,
  { data: BodyType<StaffUpdateAppointmentStatusForClientDayRequest> },
  TContext
> => {
  const mutationKey = ['statusUpdateForClientDay'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof statusUpdateForClientDay>>,
    { data: BodyType<StaffUpdateAppointmentStatusForClientDayRequest> }
  > = props => {
    const { data } = props ?? {};

    return statusUpdateForClientDay(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StatusUpdateForClientDayMutationResult = NonNullable<
  Awaited<ReturnType<typeof statusUpdateForClientDay>>
>;
export type StatusUpdateForClientDayMutationBody =
  BodyType<StaffUpdateAppointmentStatusForClientDayRequest>;
export type StatusUpdateForClientDayMutationError = ErrorType<unknown>;

export const useStatusUpdateForClientDay = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof statusUpdateForClientDay>>,
      TError,
      { data: BodyType<StaffUpdateAppointmentStatusForClientDayRequest> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof statusUpdateForClientDay>>,
  TError,
  { data: BodyType<StaffUpdateAppointmentStatusForClientDayRequest> },
  TContext
> => {
  const mutationOptions = getStatusUpdateForClientDayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const availableTimes = (
  params: AvailableTimesParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<AvailableTimes200>(
    { url: `/staff/available-times`, method: 'GET', params },
    options
  );
};

export const getAvailableTimesQueryKey = (params?: AvailableTimesParams) => {
  return [`/staff/available-times`, ...(params ? [params] : [])] as const;
};

export const getAvailableTimesQueryOptions = <
  TData = Awaited<ReturnType<typeof availableTimes>>,
  TError = ErrorType<unknown>
>(
  params: AvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof availableTimes>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAvailableTimesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableTimes>>
  > = () => availableTimes(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof availableTimes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AvailableTimesQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableTimes>>
>;
export type AvailableTimesQueryError = ErrorType<unknown>;

export function useAvailableTimes<
  TData = Awaited<ReturnType<typeof availableTimes>>,
  TError = ErrorType<unknown>
>(
  params: AvailableTimesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof availableTimes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof availableTimes>>,
          TError,
          Awaited<ReturnType<typeof availableTimes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAvailableTimes<
  TData = Awaited<ReturnType<typeof availableTimes>>,
  TError = ErrorType<unknown>
>(
  params: AvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof availableTimes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof availableTimes>>,
          TError,
          Awaited<ReturnType<typeof availableTimes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAvailableTimes<
  TData = Awaited<ReturnType<typeof availableTimes>>,
  TError = ErrorType<unknown>
>(
  params: AvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof availableTimes>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAvailableTimes<
  TData = Awaited<ReturnType<typeof availableTimes>>,
  TError = ErrorType<unknown>
>(
  params: AvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof availableTimes>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAvailableTimesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const sendConfirmationEmailForAppointments = (
  staffSendConfirmationEmailRequestPayload: BodyType<StaffSendConfirmationEmailRequestPayload>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<SendConfirmationEmailForAppointments200>(
    {
      url: `/staff/appointments/send-confirmation-email`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffSendConfirmationEmailRequestPayload
    },
    options
  );
};

export const getSendConfirmationEmailForAppointmentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendConfirmationEmailForAppointments>>,
    TError,
    { data: BodyType<StaffSendConfirmationEmailRequestPayload> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendConfirmationEmailForAppointments>>,
  TError,
  { data: BodyType<StaffSendConfirmationEmailRequestPayload> },
  TContext
> => {
  const mutationKey = ['sendConfirmationEmailForAppointments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendConfirmationEmailForAppointments>>,
    { data: BodyType<StaffSendConfirmationEmailRequestPayload> }
  > = props => {
    const { data } = props ?? {};

    return sendConfirmationEmailForAppointments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendConfirmationEmailForAppointmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendConfirmationEmailForAppointments>>
>;
export type SendConfirmationEmailForAppointmentsMutationBody =
  BodyType<StaffSendConfirmationEmailRequestPayload>;
export type SendConfirmationEmailForAppointmentsMutationError =
  ErrorType<unknown>;

export const useSendConfirmationEmailForAppointments = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendConfirmationEmailForAppointments>>,
      TError,
      { data: BodyType<StaffSendConfirmationEmailRequestPayload> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sendConfirmationEmailForAppointments>>,
  TError,
  { data: BodyType<StaffSendConfirmationEmailRequestPayload> },
  TContext
> => {
  const mutationOptions =
    getSendConfirmationEmailForAppointmentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const schedulableItemsV1 = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<SchedulableItemsV1200>(
    { url: `/staff/appointment-slots/${id}/schedulable-items`, method: 'GET' },
    options
  );
};

export const getSchedulableItemsV1QueryKey = (id?: number) => {
  return [`/staff/appointment-slots/${id}/schedulable-items`] as const;
};

export const getSchedulableItemsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof schedulableItemsV1>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItemsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSchedulableItemsV1QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulableItemsV1>>
  > = () => schedulableItemsV1(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulableItemsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SchedulableItemsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulableItemsV1>>
>;
export type SchedulableItemsV1QueryError = ErrorType<unknown>;

export function useSchedulableItemsV1<
  TData = Awaited<ReturnType<typeof schedulableItemsV1>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItemsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schedulableItemsV1>>,
          TError,
          Awaited<ReturnType<typeof schedulableItemsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSchedulableItemsV1<
  TData = Awaited<ReturnType<typeof schedulableItemsV1>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItemsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schedulableItemsV1>>,
          TError,
          Awaited<ReturnType<typeof schedulableItemsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSchedulableItemsV1<
  TData = Awaited<ReturnType<typeof schedulableItemsV1>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItemsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSchedulableItemsV1<
  TData = Awaited<ReturnType<typeof schedulableItemsV1>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItemsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSchedulableItemsV1QueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const schedulableItems = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<SchedulableItems200>(
    { url: `/staff/appointment-slots/${id}/purchasable-items`, method: 'GET' },
    options
  );
};

export const getSchedulableItemsQueryKey = (id?: number) => {
  return [`/staff/appointment-slots/${id}/purchasable-items`] as const;
};

export const getSchedulableItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof schedulableItems>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSchedulableItemsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulableItems>>
  > = () => schedulableItems(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulableItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SchedulableItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulableItems>>
>;
export type SchedulableItemsQueryError = ErrorType<unknown>;

export function useSchedulableItems<
  TData = Awaited<ReturnType<typeof schedulableItems>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schedulableItems>>,
          TError,
          Awaited<ReturnType<typeof schedulableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSchedulableItems<
  TData = Awaited<ReturnType<typeof schedulableItems>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schedulableItems>>,
          TError,
          Awaited<ReturnType<typeof schedulableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSchedulableItems<
  TData = Awaited<ReturnType<typeof schedulableItems>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSchedulableItems<
  TData = Awaited<ReturnType<typeof schedulableItems>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof schedulableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSchedulableItemsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const setSchedulableItems = (
  setAppointmentSlotItemsRequestPayload: BodyType<SetAppointmentSlotItemsRequestPayload>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<SetSchedulableItems200>(
    {
      url: `/staff/appointment-slots/schedulable-items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: setAppointmentSlotItemsRequestPayload
    },
    options
  );
};

export const getSetSchedulableItemsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSchedulableItems>>,
    TError,
    { data: BodyType<SetAppointmentSlotItemsRequestPayload> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setSchedulableItems>>,
  TError,
  { data: BodyType<SetAppointmentSlotItemsRequestPayload> },
  TContext
> => {
  const mutationKey = ['setSchedulableItems'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setSchedulableItems>>,
    { data: BodyType<SetAppointmentSlotItemsRequestPayload> }
  > = props => {
    const { data } = props ?? {};

    return setSchedulableItems(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetSchedulableItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setSchedulableItems>>
>;
export type SetSchedulableItemsMutationBody =
  BodyType<SetAppointmentSlotItemsRequestPayload>;
export type SetSchedulableItemsMutationError = ErrorType<unknown>;

export const useSetSchedulableItems = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setSchedulableItems>>,
      TError,
      { data: BodyType<SetAppointmentSlotItemsRequestPayload> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setSchedulableItems>>,
  TError,
  { data: BodyType<SetAppointmentSlotItemsRequestPayload> },
  TContext
> => {
  const mutationOptions = getSetSchedulableItemsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteSchedulableItems = (
  id: number,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<DeleteSchedulableItems200>(
    {
      url: `/staff/appointment-slots/schedulable-items/${id}`,
      method: 'DELETE'
    },
    options
  );
};

export const getDeleteSchedulableItemsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchedulableItems>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSchedulableItems>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSchedulableItems'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSchedulableItems>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteSchedulableItems(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSchedulableItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchedulableItems>>
>;

export type DeleteSchedulableItemsMutationError = ErrorType<unknown>;

export const useDeleteSchedulableItems = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSchedulableItems>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSchedulableItems>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteSchedulableItemsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getSlots = (
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetSlots200>(
    { url: `/staff/slots`, method: 'GET' },
    options
  );
};

export const getGetSlotsQueryKey = () => {
  return [`/staff/slots`] as const;
};

export const getGetSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlots>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSlotsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlots>>> = () =>
    getSlots(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSlots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSlotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSlots>>
>;
export type GetSlotsQueryError = ErrorType<unknown>;

export function useGetSlots<
  TData = Awaited<ReturnType<typeof getSlots>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlots>>,
          TError,
          Awaited<ReturnType<typeof getSlots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSlots<
  TData = Awaited<ReturnType<typeof getSlots>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlots>>,
          TError,
          Awaited<ReturnType<typeof getSlots>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSlots<
  TData = Awaited<ReturnType<typeof getSlots>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSlots<
  TData = Awaited<ReturnType<typeof getSlots>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSlotsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDripIngredientsAndIvPricing = (
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetDripIngredientsAndIvPricing200>(
    { url: `/staff/drip-ingredients-and-iv-pricing`, method: 'GET' },
    options
  );
};

export const getGetDripIngredientsAndIvPricingQueryKey = () => {
  return [`/staff/drip-ingredients-and-iv-pricing`] as const;
};

export const getGetDripIngredientsAndIvPricingQueryOptions = <
  TData = Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDripIngredientsAndIvPricingQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>
  > = () => getDripIngredientsAndIvPricing(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDripIngredientsAndIvPricingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>
>;
export type GetDripIngredientsAndIvPricingQueryError = ErrorType<unknown>;

export function useGetDripIngredientsAndIvPricing<
  TData = Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
          TError,
          Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripIngredientsAndIvPricing<
  TData = Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
          TError,
          Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripIngredientsAndIvPricing<
  TData = Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDripIngredientsAndIvPricing<
  TData = Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredientsAndIvPricing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDripIngredientsAndIvPricingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCocktailIngredients = (
  params: GetCocktailIngredientsParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetCocktailIngredients200>(
    { url: `/staff/cocktail-ingredients`, method: 'GET', params },
    options
  );
};

export const getGetCocktailIngredientsQueryKey = (
  params?: GetCocktailIngredientsParams
) => {
  return [`/staff/cocktail-ingredients`, ...(params ? [params] : [])] as const;
};

export const getGetCocktailIngredientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  params: GetCocktailIngredientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCocktailIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCocktailIngredientsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCocktailIngredients>>
  > = () => getCocktailIngredients(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCocktailIngredients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCocktailIngredientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCocktailIngredients>>
>;
export type GetCocktailIngredientsQueryError = ErrorType<unknown>;

export function useGetCocktailIngredients<
  TData = Awaited<ReturnType<typeof getCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  params: GetCocktailIngredientsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCocktailIngredients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCocktailIngredients>>,
          TError,
          Awaited<ReturnType<typeof getCocktailIngredients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCocktailIngredients<
  TData = Awaited<ReturnType<typeof getCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  params: GetCocktailIngredientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCocktailIngredients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCocktailIngredients>>,
          TError,
          Awaited<ReturnType<typeof getCocktailIngredients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCocktailIngredients<
  TData = Awaited<ReturnType<typeof getCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  params: GetCocktailIngredientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCocktailIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCocktailIngredients<
  TData = Awaited<ReturnType<typeof getCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  params: GetCocktailIngredientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCocktailIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCocktailIngredientsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getServices = (
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<GetServices200>(
    { url: `/staff/services`, method: 'GET' },
    options
  );
};

export const getGetServicesQueryKey = () => {
  return [`/staff/services`] as const;
};

export const getGetServicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getServices>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetServicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getServices>>> = () =>
    getServices(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getServices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetServicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getServices>>
>;
export type GetServicesQueryError = ErrorType<unknown>;

export function useGetServices<
  TData = Awaited<ReturnType<typeof getServices>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetServices<
  TData = Awaited<ReturnType<typeof getServices>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetServices<
  TData = Awaited<ReturnType<typeof getServices>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetServices<
  TData = Awaited<ReturnType<typeof getServices>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetServicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const customerRecentServices = (
  params: CustomerRecentServicesParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<CustomerRecentServices200>(
    { url: `/staff/customer-recent-services`, method: 'GET', params },
    options
  );
};

export const getCustomerRecentServicesQueryKey = (
  params?: CustomerRecentServicesParams
) => {
  return [
    `/staff/customer-recent-services`,
    ...(params ? [params] : [])
  ] as const;
};

export const getCustomerRecentServicesQueryOptions = <
  TData = Awaited<ReturnType<typeof customerRecentServices>>,
  TError = ErrorType<unknown>
>(
  params: CustomerRecentServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerRecentServices>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCustomerRecentServicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof customerRecentServices>>
  > = () => customerRecentServices(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof customerRecentServices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CustomerRecentServicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof customerRecentServices>>
>;
export type CustomerRecentServicesQueryError = ErrorType<unknown>;

export function useCustomerRecentServices<
  TData = Awaited<ReturnType<typeof customerRecentServices>>,
  TError = ErrorType<unknown>
>(
  params: CustomerRecentServicesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerRecentServices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customerRecentServices>>,
          TError,
          Awaited<ReturnType<typeof customerRecentServices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerRecentServices<
  TData = Awaited<ReturnType<typeof customerRecentServices>>,
  TError = ErrorType<unknown>
>(
  params: CustomerRecentServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerRecentServices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customerRecentServices>>,
          TError,
          Awaited<ReturnType<typeof customerRecentServices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerRecentServices<
  TData = Awaited<ReturnType<typeof customerRecentServices>>,
  TError = ErrorType<unknown>
>(
  params: CustomerRecentServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerRecentServices>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useCustomerRecentServices<
  TData = Awaited<ReturnType<typeof customerRecentServices>>,
  TError = ErrorType<unknown>
>(
  params: CustomerRecentServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerRecentServices>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCustomerRecentServicesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const customerUpcomingAppointments = (
  params: CustomerUpcomingAppointmentsParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<CustomerUpcomingAppointments200>(
    { url: `/staff/customer-upcoming-appointments`, method: 'GET', params },
    options
  );
};

export const getCustomerUpcomingAppointmentsQueryKey = (
  params?: CustomerUpcomingAppointmentsParams
) => {
  return [
    `/staff/customer-upcoming-appointments`,
    ...(params ? [params] : [])
  ] as const;
};

export const getCustomerUpcomingAppointmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof customerUpcomingAppointments>>,
  TError = ErrorType<unknown>
>(
  params: CustomerUpcomingAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerUpcomingAppointments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCustomerUpcomingAppointmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof customerUpcomingAppointments>>
  > = () => customerUpcomingAppointments(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof customerUpcomingAppointments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CustomerUpcomingAppointmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof customerUpcomingAppointments>>
>;
export type CustomerUpcomingAppointmentsQueryError = ErrorType<unknown>;

export function useCustomerUpcomingAppointments<
  TData = Awaited<ReturnType<typeof customerUpcomingAppointments>>,
  TError = ErrorType<unknown>
>(
  params: CustomerUpcomingAppointmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerUpcomingAppointments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customerUpcomingAppointments>>,
          TError,
          Awaited<ReturnType<typeof customerUpcomingAppointments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerUpcomingAppointments<
  TData = Awaited<ReturnType<typeof customerUpcomingAppointments>>,
  TError = ErrorType<unknown>
>(
  params: CustomerUpcomingAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerUpcomingAppointments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customerUpcomingAppointments>>,
          TError,
          Awaited<ReturnType<typeof customerUpcomingAppointments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerUpcomingAppointments<
  TData = Awaited<ReturnType<typeof customerUpcomingAppointments>>,
  TError = ErrorType<unknown>
>(
  params: CustomerUpcomingAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerUpcomingAppointments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useCustomerUpcomingAppointments<
  TData = Awaited<ReturnType<typeof customerUpcomingAppointments>>,
  TError = ErrorType<unknown>
>(
  params: CustomerUpcomingAppointmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof customerUpcomingAppointments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCustomerUpcomingAppointmentsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const multiDayAvailableTimes = (
  params: MultiDayAvailableTimesParams,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<MultiDayAvailableTimes200>(
    { url: `/staff/available-times/multi-day`, method: 'GET', params },
    options
  );
};

export const getMultiDayAvailableTimesQueryKey = (
  params?: MultiDayAvailableTimesParams
) => {
  return [
    `/staff/available-times/multi-day`,
    ...(params ? [params] : [])
  ] as const;
};

export const getMultiDayAvailableTimesQueryOptions = <
  TData = Awaited<ReturnType<typeof multiDayAvailableTimes>>,
  TError = ErrorType<unknown>
>(
  params: MultiDayAvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof multiDayAvailableTimes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMultiDayAvailableTimesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof multiDayAvailableTimes>>
  > = () => multiDayAvailableTimes(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof multiDayAvailableTimes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MultiDayAvailableTimesQueryResult = NonNullable<
  Awaited<ReturnType<typeof multiDayAvailableTimes>>
>;
export type MultiDayAvailableTimesQueryError = ErrorType<unknown>;

export function useMultiDayAvailableTimes<
  TData = Awaited<ReturnType<typeof multiDayAvailableTimes>>,
  TError = ErrorType<unknown>
>(
  params: MultiDayAvailableTimesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof multiDayAvailableTimes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof multiDayAvailableTimes>>,
          TError,
          Awaited<ReturnType<typeof multiDayAvailableTimes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMultiDayAvailableTimes<
  TData = Awaited<ReturnType<typeof multiDayAvailableTimes>>,
  TError = ErrorType<unknown>
>(
  params: MultiDayAvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof multiDayAvailableTimes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof multiDayAvailableTimes>>,
          TError,
          Awaited<ReturnType<typeof multiDayAvailableTimes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMultiDayAvailableTimes<
  TData = Awaited<ReturnType<typeof multiDayAvailableTimes>>,
  TError = ErrorType<unknown>
>(
  params: MultiDayAvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof multiDayAvailableTimes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useMultiDayAvailableTimes<
  TData = Awaited<ReturnType<typeof multiDayAvailableTimes>>,
  TError = ErrorType<unknown>
>(
  params: MultiDayAvailableTimesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof multiDayAvailableTimes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getMultiDayAvailableTimesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const cancelAppointment = (
  id: number,
  staffCancelAppointmentRequestPayload: BodyType<StaffCancelAppointmentRequestPayload>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<CancelAppointment200>(
    {
      url: `/staff/appointments/${id}/cancel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCancelAppointmentRequestPayload
    },
    options
  );
};

export const getCancelAppointmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelAppointment>>,
    TError,
    { id: number; data: BodyType<StaffCancelAppointmentRequestPayload> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelAppointment>>,
  TError,
  { id: number; data: BodyType<StaffCancelAppointmentRequestPayload> },
  TContext
> => {
  const mutationKey = ['cancelAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelAppointment>>,
    { id: number; data: BodyType<StaffCancelAppointmentRequestPayload> }
  > = props => {
    const { id, data } = props ?? {};

    return cancelAppointment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelAppointmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelAppointment>>
>;
export type CancelAppointmentMutationBody =
  BodyType<StaffCancelAppointmentRequestPayload>;
export type CancelAppointmentMutationError = ErrorType<unknown>;

export const useCancelAppointment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelAppointment>>,
      TError,
      { id: number; data: BodyType<StaffCancelAppointmentRequestPayload> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cancelAppointment>>,
  TError,
  { id: number; data: BodyType<StaffCancelAppointmentRequestPayload> },
  TContext
> => {
  const mutationOptions = getCancelAppointmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const missedAppointment = (
  id: number,
  staffMissedAppointmentRequestPayload: BodyType<StaffMissedAppointmentRequestPayload>,
  options?: SecondParameter<typeof bookingApiInstance>
) => {
  return bookingApiInstance<MissedAppointment200>(
    {
      url: `/staff/appointments/${id}/missed`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffMissedAppointmentRequestPayload
    },
    options
  );
};

export const getMissedAppointmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof missedAppointment>>,
    TError,
    { id: number; data: BodyType<StaffMissedAppointmentRequestPayload> },
    TContext
  >;
  request?: SecondParameter<typeof bookingApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof missedAppointment>>,
  TError,
  { id: number; data: BodyType<StaffMissedAppointmentRequestPayload> },
  TContext
> => {
  const mutationKey = ['missedAppointment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof missedAppointment>>,
    { id: number; data: BodyType<StaffMissedAppointmentRequestPayload> }
  > = props => {
    const { id, data } = props ?? {};

    return missedAppointment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MissedAppointmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof missedAppointment>>
>;
export type MissedAppointmentMutationBody =
  BodyType<StaffMissedAppointmentRequestPayload>;
export type MissedAppointmentMutationError = ErrorType<unknown>;

export const useMissedAppointment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof missedAppointment>>,
      TError,
      { id: number; data: BodyType<StaffMissedAppointmentRequestPayload> },
      TContext
    >;
    request?: SecondParameter<typeof bookingApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof missedAppointment>>,
  TError,
  { id: number; data: BodyType<StaffMissedAppointmentRequestPayload> },
  TContext
> => {
  const mutationOptions = getMissedAppointmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
